import * as React from 'react'
import { Ref } from 'react'

interface Props {
  title: string
  children: React.ReactNode
}

export const ScrollableSection = React.forwardRef(
  ({ title, children }: Props, ref: Ref<HTMLDivElement>): JSX.Element => (
    <div ref={ref} className="mb-5">
      <h4 className="fw-bold text-center mb-3 text-xl-start scrollable-section__title">{title}</h4>
      {children}
    </div>
  ),
)
